/**
 * Order TransactionType from the perspective of the business.
 **/
export const TransactionTypes = {
  /** Sale of currency to a customer i.e. B2C. **/
  SELL: "sell",
  /** Purchase of currency from a customer i.e. C2B. **/
  BUY: "buy"
};
